import { ApiGetOrderRentalList, ApiOrderRentalDelivered, ApiOrderRentalReturned } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function RentalOrderService() {
    const { showFail } = useModal()

    const { fetch: apiOrderRentalDelivered } = useFetch(ApiOrderRentalDelivered)
    const { fetch: apiOrderRentalReturned } = useFetch(ApiOrderRentalReturned)
    const { fetch: apiGetRentalOrderList } = useFetch(ApiGetOrderRentalList)

    const fetchRentalOrderList = async(rentalDateFrom, rentalDateTo, customerName, rentalStatus, paymentType, status, pageSize, pageIndex, deliveryStatus) => {
        const res = await apiGetRentalOrderList({
            data: {
                rentalDateFrom,
                rentalDateTo,
                customerName,
                rentalStatus,
                paymentType,
                status,
                pageSize,
                pageIndex,
                deliveryStatus
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeliverRental = async (rentalOrderId) => {
        const res = await apiOrderRentalDelivered({
            data: { rentalOrderId }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchReturnRental = async (rentalOrderId, returnedCondition, returnedNotes, returnDate) => {
        const res = await apiOrderRentalReturned({
            data: {
                rentalOrderId,
                returnedCondition,
                returnedNotes,
                returnDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchRentalOrderList,
        fetchDeliverRental,
        fetchReturnRental
    }
}